var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.14527 5.17859H12.6402C13.8448 5.17859 14.8213 6.15511 14.8213 7.35971V15.8546C14.8213 17.0592 13.8448 18.0357 12.6402 18.0357H4.14527C2.94067 18.0357 1.96415 17.0592 1.96415 15.8546V7.35971C1.96415 6.15511 2.94067 5.17859 4.14527 5.17859Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.19812 5.02546L5.17899 4.10709C5.18061 3.53927 5.40689 2.99516 5.8084 2.59365C6.20992 2.19213 6.75402 1.96585 7.32185 1.96423H15.5872C16.2361 1.96615 16.8579 2.22478 17.3167 2.68364C17.7756 3.1425 18.0342 3.76429 18.0361 4.41321V12.6785C18.0345 13.2463 17.8082 13.7904 17.4067 14.192C17.0052 14.5935 16.4611 14.8198 15.8933 14.8214H14.9749",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.b7fe2ada4b09bd9f4a6f0b5e9e3af69d.svg";
export { ForwardRef as ReactComponent };